import React from 'react';
import { SparkleIcon } from 'lucide-react';
export const Footer: React.FC = () => <footer className="relative bg-navy-deep border-t border-ivory/10 py-14 px-6 lg:px-8" data-id="element-163">
    <div className="max-w-6xl mx-auto" data-id="element-164">
      <div className="grid md:grid-cols-3 gap-10 mb-10" data-id="element-165">
        <div data-id="element-166">
          <div className="flex items-center gap-2 mb-4" data-id="element-167">
            <SparkleIcon className="w-4 h-4 text-gold" strokeWidth={1.5} data-id="element-168" />
            <span className="font-serif italic text-ivory text-base" data-id="element-169">
              Daniel Navarro
            </span>
          </div>
          <p className="font-serif text-ivory/60 text-sm leading-snug" data-id="element-170">
            La Estabilidad Dimensional
            <br data-id="element-171" />
            de Nuestro Ser
          </p>
        </div>
        <div data-id="element-172">
          <p className="text-xs uppercase tracking-[0.25em] text-gold/70 mb-3" data-id="element-173">
            Producto
          </p>
          <p className="text-ivory/60 text-sm font-light" data-id="element-174">
            Libro digital en PDF
          </p>
          <p className="text-ivory/60 text-sm font-light" data-id="element-175">Acceso instantáneo</p>
          <p className="text-ivory/60 text-sm font-light" data-id="element-176">Edición en español</p>
        </div>
        <div data-id="element-177">
          <p className="text-xs uppercase tracking-[0.25em] text-gold/70 mb-3" data-id="element-178">
            Soporte
          </p>
          <a href="mailto:[ADD SUPPORT EMAIL HERE]" className="text-ivory/60 text-sm font-light hover:text-gold transition-colors" data-id="element-179">
            [ADD SUPPORT EMAIL HERE]
          </a>
        </div>
      </div>
      <div className="pt-8 border-t border-ivory/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-ivory/40" data-id="element-180">
        <p data-id="element-181">© 2025 Daniel Navarro. Todos los derechos reservados.</p>
        <p className="font-serif italic" data-id="element-182">Con apoyo creativo de César Navarro</p>
      </div>
    </div>
  </footer>;